import request from './base';
import {excludeObjNullValue, camelToSnake} from 'utils/common';


export const createQuestion = (payload) => request.postJSON(
    '/questions',
    excludeObjNullValue({
        name: payload.name,
        content: payload.content,
        topic: payload.topic,
        subtopic: payload.subtopic,
        answers: payload.answers || [],
        question_type: payload.questionType,
        supplements: camelToSnake(payload.supplements || []),
        randomize_answers: payload.randomize_answers,
    })
);

export const updateQuestion = (id, payload) => request.postJSON(
    `/questions/${id}`,
    excludeObjNullValue({
        name: payload.name,
        content: payload.content,
        topic: payload.topic,
        subtopic: payload.subtopic,
        answers: payload.answers || [],
        supplements: camelToSnake(payload.supplements || []),
        randomize_answers: payload.randomize_answers,
    })
);

export const fetchQuestions = ({q, page, perPage, sortOpts, extraParams}) => (
    request.fetchList({url: '/questions', q, page, perPage, sortOpts, extraParams})
);

export const fetchCurrentQuizQuestions = ({quizId, q, page, perPage, sortOpts, extraParams}) => (
    request.fetchList({url: `/quizzes/${quizId}/questions`, q, page, perPage, sortOpts, extraParams})
);

export const fetchQuestion = (id) => request.fetchDetail(`/questions/${id}`);

export const deleteQuestion = (questionId) => request.deleteReq(`/questions/${questionId}`);

export const addSuplementToQuestion = (id, payload) => request.postJSON(
    `/questions/${id}/supplements`,
    excludeObjNullValue({
        mimetype: payload.mimetype,
        url: payload.url,
        filesize: payload.fileSize
    })
);

export const deleteSuplementFromQuestion = (questionId, supplementId) => request.deleteReq(
    `/questions/${questionId}/supplements/${supplementId}`
);
